import apiClient from './Api';
const PREFIX = '/setting';

const prestockUpload = postData => {
  return apiClient({
    url: `${PREFIX}/uploadprestock`,
    method: 'POST',
    data: postData
  });
};

const stickerUpload = postData => {
  return apiClient({
    url: `${PREFIX}/uploadwindowstickerframe`,
    method: 'POST',
    data: postData
  });
};

const stickerRemove = postData => {
  return apiClient({
    url: `${PREFIX}/deletesticker`,
    method: 'POST',
    data: postData
  });
};

// const changeApplyps = postData => {
//   return apiClient({
//     url: `${PREFIX}/changeapplyps`,
//     method: 'POST',
//     data: postData
//   });
// };

const prestockRemove = postData => {
  return apiClient({
    url: `${PREFIX}/deleteprestock`,
    method: 'POST',
    data: postData
  });
};

const getDealerSourceName = postData => {
  return apiClient({
    url: `${PREFIX}/dealersourcenames`,
    method: 'POST',
    data: postData
  });
};

const getDealerSourceNameReorder = postData => {
  return apiClient({
    url: `${PREFIX}/dealersourcenamesreorder`,
    method: 'POST',
    data: postData
  });
};

const updateDealerSourceName = postData => {
  return apiClient({
    url: `${PREFIX}/updatedealersourcenames`,
    method: 'POST',
    data: postData
  });
};

const updateReorderShots = postData => {
  return apiClient({
    url: `${PREFIX}/updatedealerorder`,
    method: 'POST',
    data: postData
  });
};

const uploadStaticShot = postData => {
  return apiClient({
    url: `${PREFIX}/uploadstatic`,
    method: 'POST',
    data: postData
  });
};

const updateStaticShot = postData => {
  return apiClient({
    url: `${PREFIX}/updatestatic`,
    method: 'POST',
    data: postData
  });
};

const importShots = postData => {
  return apiClient({
    url: `${PREFIX}/importdealershots`,
    method: 'POST',
    data: postData
  });
};

const importDefaultShots = postData => {
  return apiClient({
    url: `${PREFIX}/importdefaultshots`,
    method: 'POST',
    data: postData
  });
};

const getCompositions = () => {
  return apiClient({
    url: `${PREFIX}/getCompositions`,
    method: 'GET'
  });
};

const getCompositionDetails = cmpId => {
  return apiClient({
    url: `${PREFIX}/getCompositionDetails`,
    method: 'POST',
    data: cmpId
  });
};

const saveComposition = postData => {
  return apiClient({
    url: `${PREFIX}/saveComposition`,
    method: 'POST',
    data: postData
  });
};

const deleteDefaultComposition = tempId => {
  return apiClient({
    url: `${PREFIX}/deleteDefaultComposition`,
    method: 'POST',
    data: tempId
  });
};

const getDealerShots = dealerId => {
  return apiClient({
    url: `${PREFIX}/getDealerShots`,
    method: 'POST',
    data: dealerId
  });
};

const getMasterShotData = () => {
  return apiClient({
    url: `${PREFIX}/mastershots`,
    method: 'GET'
  });
};

const addShot = postData => {
  return apiClient({
    url: `${PREFIX}/addshot`,
    method: 'POST',
    data: postData
  });
};

const updateShot = postData => {
  return apiClient({
    url: `${PREFIX}/updateshot`,
    method: 'POST',
    data: postData
  });
};

const uploadComposition = postData => {
  return apiClient({
    url: `${PREFIX}/uploadcomposition`,
    method: 'POST',
    data: postData
  });
};

const deleteComposition = postData => {
  return apiClient({
    url: `${PREFIX}/deletecomposition`,
    method: 'POST',
    data: postData
  });
};

const deleteDefaultCmpImage = postData => {
  return apiClient({
    url: `${PREFIX}/deleteDefaultCmpImage`,
    method: 'POST',
    data: postData
  });
};

const getShotComp = postData => {
  return apiClient({
    url: `${PREFIX}/shotcomposition`,
    method: 'POST',
    data: postData
  });
};

const updateBoundBoxDetails = postData => {
  return apiClient({
    url: `${PREFIX}/updateBoundBoxDetails`,
    method: 'POST',
    data: postData
  });
};

const getBoundBoxDetails = postData => {
  return apiClient({
    url: `${PREFIX}/getBoundBoxDetails`,
    method: 'POST',
    data: postData
  });
};

const dealerMavis = postData => {
  return apiClient({
    url: `${PREFIX}/dealermavis`,
    method: 'POST',
    data: postData
  });
};

// NOT IN USE
const dealerMavisSettings = postData => {
  return apiClient({
    url: `${PREFIX}/dealermavissettings`,
    method: 'POST',
    data: postData
  });
};

const allCompositionMavisSettings = postData => {
  return apiClient({
    url: `${PREFIX}/allcompositionMavisSettings`,
    method: 'POST',
    data: postData
  });
};

const allCompositionsExceptPA = postData => {
  return apiClient({
    url: `${PREFIX}/allcompositionsexceptpa`,
    method: 'POST',
    data: postData
  });
};

// NOT IN USE
const dealerMavisProcessOld = postData => {
  return apiClient({
    url: `${PREFIX}/processold`,
    method: 'POST',
    data: postData
  });
};

// NOT IN USE
const dealerMavisOverlayUpload = postData => {
  return apiClient({
    url: `${PREFIX}/uploadframe`,
    method: 'POST',
    data: postData
  });
};

// NOT IN USE
const dealerDmsOverlayUpload = postData => {
  return apiClient({
    url: `${PREFIX}/uploaddmsframe`,
    method: 'POST',
    data: postData
  });
};

// NOT IN USE
const dealerDmsOverlayRemove = postData => {
  return apiClient({
    url: `${PREFIX}/removedmsframe`,
    method: 'POST',
    data: postData
  });
};

// NOT IN USE
const dealerCertifiedOverlayUpload = postData => {
  return apiClient({
    url: `${PREFIX}/uploadcertifiedframe`,
    method: 'POST',
    data: postData
  });
};

// NOT IN USE
const dealerCertifiedOverlayRemove = postData => {
  return apiClient({
    url: `${PREFIX}/removecertifiedframe`,
    method: 'POST',
    data: postData
  });
};

const dealerSavePhotoSetting = postData => {
  return apiClient({
    url: `${PREFIX}/savephotosettings`,
    method: 'POST',
    data: postData
  });
};

const dealerClearAllRemoveBGPhotoSettings = postData => {
  return apiClient({
    url: `${PREFIX}/clearAllRemoveBGPhotoSettings`,
    method: 'POST',
    data: postData
  });
};

const saveRemoveBg = postData => {
  return apiClient({
    url: `${PREFIX}/saveremovebg`,
    method: 'POST',
    data: postData
  });
};

const saveIsOverlaySetting = postData => {
  return apiClient({
    url: `${PREFIX}/saveisoverlaysettings`,
    method: 'POST',
    data: postData
  });
};

// NOT IN USE
const saveGhostOverlaySetting = postData => {
  return apiClient({
    url: `${PREFIX}/saveghostoverlaysetting`,
    method: 'POST',
    data: postData
  });
};

const applyToAll = postData => {
  return apiClient({
    url: `${PREFIX}/applytoall`,
    method: 'POST',
    data: postData
  });
};

// NOT IN USE
const saveApplyAllSetting = postData => {
  return apiClient({
    url: `${PREFIX}/saveapplyalltype`,
    method: 'POST',
    data: postData
  });
};

// NOT IN USE
const saveGhostallType = postData => {
  return apiClient({
    url: `${PREFIX}/saveghostalltype`,
    method: 'POST',
    data: postData
  });
};

const savePaSettings = postData => {
  return apiClient({
    url: `${PREFIX}/pa-settings`,
    method: 'POST',
    data: postData
  });
};

const getPaSettings = () => {
  return apiClient({
    url: `${PREFIX}/pa-settings`,
    method: 'GET'
  });
};

const saveGlobleSettings = postData => {
  return apiClient({
    url: `${PREFIX}/savegloblesettings`,
    method: 'POST',
    data: postData
  });
};

const getGlobleSettings = () => {
  return apiClient({
    url: `${PREFIX}/getgloblesetting`,
    method: 'GET'
  });
};

const getBigMassPublishStatus = () => {
  return apiClient({
    url: `${PREFIX}/getbigmasspublishstatus`,
    method: 'GET'
  });
};

const getBigMassPublishData = postData => {
  return apiClient({
    url: `${PREFIX}/getbigmasspublishdata`,
    method: 'POST',
    data: postData
  });
};

const startBigMassPublish = postData => {
  return apiClient({
    url: `${PREFIX}/startbigmasspublish`,
    method: 'POST',
    data: postData
  });
};

const kudosList = postData => {
  return apiClient({
    url: `${PREFIX}/kudoslist`,
    method: 'POST',
    data: postData
  });
};

const SettingService = {
  prestockUpload,
  // changeApplyps,
  prestockRemove,
  getDealerSourceName,
  getDealerSourceNameReorder,
  updateDealerSourceName,
  updateReorderShots,
  uploadStaticShot,
  updateStaticShot,
  importShots,
  importDefaultShots,
  getCompositions,
  getCompositionDetails,
  saveComposition,
  deleteDefaultComposition,
  getDealerShots,
  getMasterShotData,
  addShot,
  updateShot,
  uploadComposition,
  deleteComposition,
  deleteDefaultCmpImage,
  getShotComp,
  updateBoundBoxDetails,
  getBoundBoxDetails,
  dealerMavis,
  dealerMavisSettings,
  allCompositionMavisSettings,
  allCompositionsExceptPA,
  dealerMavisProcessOld,
  dealerMavisOverlayUpload,
  dealerDmsOverlayUpload,
  dealerDmsOverlayRemove,
  dealerCertifiedOverlayUpload,
  dealerCertifiedOverlayRemove,
  dealerSavePhotoSetting,
  dealerClearAllRemoveBGPhotoSettings,
  saveRemoveBg,
  saveIsOverlaySetting,
  saveGhostOverlaySetting,
  applyToAll,
  saveApplyAllSetting,
  saveGhostallType,
  savePaSettings,
  getPaSettings,
  saveGlobleSettings,
  getGlobleSettings,
  getBigMassPublishStatus,
  getBigMassPublishData,
  startBigMassPublish,
  stickerUpload,
  stickerRemove,
  kudosList
};

export default SettingService;
